import { IconButton, Popover } from '@mui/material'
import PopupState, { bindPopover, bindTrigger } from 'material-ui-popup-state'
import DeleteIcon from '@mui/icons-material/Delete'
import { CustomButton } from 'components/ui'
import { useDeleteBimlink } from 'hooks/useDeleteBimLink'
import { useState } from 'react'
import BimLinkDeleteModal from './BimLinkDeleteModal'
import { Tooltip } from 'react-tooltip'

const DeleteBimLinkButton = ({ bimlink }) => {
  const [isBimLinkInUse, setIsBimLinkInUse] = useState(false)
  const { deleteBimlink, isLoading } = useDeleteBimlink(
    bimlink._id,
    setIsBimLinkInUse
  )

  const handleOnClose = () => {
    setIsBimLinkInUse(false)
  }

  return (
    <>
      <PopupState variant="popover" popupId="pop-over-delete">
        {popupState => (
          <div>
            <Tooltip
                anchorSelect=".test123"
                style={{ zIndex: '99999999', fontSize: '10px' }}
                  >
                    Eliminar Bimblink
            </Tooltip>
              <IconButton className='test123' onClick={e => e.stopPropagation()}>
                <DeleteIcon {...bindTrigger(popupState)} fontSize="large" />
              </IconButton>
            
            <Popover
              {...bindPopover(popupState)}
              onClick={e => e.stopPropagation()}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'center',
                horizontal: 'left',
              }}
            >
              <div style={{ padding: '1rem' }}>
                <p style={{ fontSize: '1.2rem' }}>
                  {`¿Estás seguro que quieres eliminar este BimLink?`}
                </p>
                <div className="popover-container">
                  <CustomButton
                    type="primary"
                    className="button-popover"
                    onClick={() => {
                      popupState.setOpen(false)
                    }}
                  >
                    No
                  </CustomButton>
                  <CustomButton
                    type="secondary"
                    className="button-popover"
                    onClick={() => {
                      popupState.setOpen(false)
                      deleteBimlink()
                    }}
                  >
                    Sí
                  </CustomButton>
                </div>
              </div>
            </Popover>
          </div>
        )}
      </PopupState>
      <BimLinkDeleteModal
        isBimLinkInUse={isBimLinkInUse}
        isLoading={isLoading}
        onClose={handleOnClose}
      />
    </>
  )
}

export default DeleteBimLinkButton
